import MemberProfile from './MemberProfileForm';

export default MemberProfile;
